import { Component, OnDestroy } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: false
})
export class HelpComponent implements OnDestroy {
  currentLanguage: string;
  domain: string;

  protected readonly onDestroy$ = new Subject<void>();

  constructor(private languageService: LanguageService) {
    this.languageService.selected.pipe(takeUntil(this.onDestroy$)).subscribe((countryLanguage) => {
      const [language, country] = countryLanguage.split('-');
      this.currentLanguage = language;
      this.domain = country.toLowerCase();
    });
  }

  openFAQ(): void {
    const url = `https://help.inyova.${this.domain}/hc/${this.currentLanguage}`;
    window.open(url, 'blank');
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
